import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button, ButtonText } from '@/components/ui/button'
import useAuthStore from '@/store/useAuthStore'
import useGetCurrentUser from '@/services/api/auth/useGetCurrentUser'
import {
  useMarketingWording,
  useSaveMarketingChoice,
} from '@/services/api/auth/useMarketingConsent'

/**
 * One-time in-app ask for users who never chose (they signed up before
 * consent capture), once they have a Vault. The API decides when it is due;
 * any answer — closing it included — is final, so it never comes back.
 * Never sent by email: asking for consent by email is itself a breach.
 */
export default function MarketingPromptDialog() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const { data: currentUser } = useGetCurrentUser(isAuthenticated)
  const { data: wording } = useMarketingWording()
  const { saveChoice, saveChoiceStatus } = useSaveMarketingChoice()

  if (!currentUser?.marketing_prompt_due || !wording) return null

  const answer = (optedIn: boolean) => {
    if (saveChoiceStatus.isPending) return
    saveChoice({
      optedIn,
      source: 'in_app_prompt',
      wordingVersion: wording.version,
    }).catch(() => {})
  }

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) answer(false)
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Get tips by email?</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <DialogDescription>{wording.text}</DialogDescription>
        </DialogBody>
        <DialogFooter>
          <Button
            variant="secondary"
            disabled={saveChoiceStatus.isPending}
            onClick={() => answer(false)}
          >
            <ButtonText>No thanks</ButtonText>
          </Button>
          <Button
            loading={saveChoiceStatus.isPending}
            onClick={() => answer(true)}
          >
            <ButtonText>Yes, send me tips</ButtonText>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
